module.exports = __webpack_public_path__ + "img/state.4b668c78.png";